export default __webpack_public_path__ + "static/media/showMore.37693bd9.svg";